import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MaskedInput from 'react-text-mask';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  signupTextField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
  },
  button: {
    marginTop: theme.spacing.unit * 4,
  },
});

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      keepCharPositions={true}
      placeholderChar={'\u2000'}
    />
  );
}

const SignUpForm = props => {
  const {
    classes,
    handleSubmit,
    handleChange,
    validateForm,
    phoneNumber,
  } = props;

  return (
    <form
      onSubmit={handleSubmit}
      className={classes.container}
      noValidate
      autoComplete="off"
    >
      <TextField
        required
        id="fullName"
        label="Full Name"
        className={classes.signupTextField}
        margin="normal"
        onChange={handleChange}
      />

      <TextField
        required
        id="phoneNumber"
        placeholder="(xxx) xxx-xxxx"
        label="Cell Phone"
        value={phoneNumber}
        className={classes.signupTextField}
        margin="normal"
        onChange={handleChange}
        InputProps={{
          inputComponent: TextMaskCustom,
        }}
        helperText="Enter a valid 10 digit US cell phone number."
      />

      <TextField
        required
        id="email"
        label="Email"
        className={classes.signupTextField}
        margin="normal"
        onChange={handleChange}
      />

      <TextField
        required
        id="password"
        label="Password"
        className={classes.signupTextField}
        type="password"
        margin="normal"
        onChange={handleChange}
        helperText={`Password must be atleast 8 characters long and must contain atleast 1 number, 1 uppercase , 1 lowercase and 1 special character(!@#$%^&*). For example - 9Thimj@r`}
      />

      <TextField
        required
        id="confirmPassword"
        label="Confirm Password"
        className={classes.signupTextField}
        type="password"
        margin="normal"
        onChange={handleChange}
      />

      <Button
        variant="raised"
        color="primary"
        className={classes.button}
        disabled={!validateForm()}
        type="submit"
      >
        Sign Up
      </Button>
    </form>
  );
};

export default withStyles(styles)(SignUpForm);



// WEBPACK FOOTER //
// ./src/components/SignUpForm.js